import {Component, Output, EventEmitter} from "@angular/core";

@Component({
  selector: "app-user-corner-popup",
  templateUrl: "./user-corner-popup.component.html",
  styleUrls: ["./user-corner-popup.component.scss"],
})
export class UserCornerPopupComponent {
  @Output() logout = new EventEmitter<void>();
  @Output() userSettings = new EventEmitter<void>();

  onLogoutClick(): void {
    this.logout.emit();
  }

  onSettingsClick(): void {
    this.userSettings.emit();
  }
}
